import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=6bea878d&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea878d",
  null
  
)

export default component.exports